import React, {
  useEffect,
  useState,
  Suspense,
  lazy,
} from 'react'
import './App.css'
import './Animations.scss'
import {
  Route,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom'
import { ThemeProvider } from '@emotion/react'
import theme from './utils/themes/mainTheme'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'
import PermissionsProvider from './components/PermissionsProvider/PermissionsProvider'
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute'
// import { SUPPLIERS__LIST } from './constants/SuppliersList'
import { useSuppliersList } from './constants/SuppliersList'

import { mainApi } from './store/services/mainApi'
import LoadingFallback from './components/UI/LoadingFallback/LoadingFallback'

// Critical components - load immediately
import Header from './components/Header/Header'
import Autorization from './components/Autorization/Autorization'


// Lazy load route components for code splitting
const Orders = lazy(
  () => import('./components/Orders/Orders'),
)
const Contacts = lazy(
  () => import('./components/Contacts/Contacts'),
)
const ContactChange = lazy(
  () =>
    import(
      './components/Contacts/ContactChange/ContactChange'
    ),
)
const OrdersChange = lazy(
  () =>
    import('./components/Orders/OrdersChange/OrdersChange'),
)
const Catalog = lazy(
  () => import('./components/Catalog/Catalog'),
)
const CatalogChange = lazy(
  () =>
    import(
      './components/Catalog/CatalogChange/CatalogChange'
    ),
)
const History = lazy(
  () => import('./components/History/History'),
)
const StaticPage = lazy(
  () => import('./components/StaticPage/StaticPage'),
)
const OrdersHistory = lazy(
  () =>
    import(
      './components/Orders/OrdersHistory/OrdersHistory'
    ),
)
const Profile = lazy(
  () => import('./components/Profile/Profile'),
)
const ShipmentOrders = lazy(
  () => import('./components/Shipment/ShipmentOrders'),
)
const JuiceProduction = lazy(
  () => import('./components/Juice/JuiceProduction'),
)
const StaticOrderFP = lazy(() =>
  import(
    './components/StaticOrder/StaticOrderFP/StaticOrderFP'
  ).then((module) => ({ default: module.StaticOrderFP })),
)
const WelcomePage = lazy(
  () => import('./components/WelcomePage/WelcomePage'),
)
const ContactStats = lazy(() =>
  import(
    './components/Contacts/ContactStats/ContactStats'
  ).then((module) => ({ default: module.ContactStats })),
)
const LogsPage = lazy(
  () => import('./components/LogsPage/LogsPage'),
)
const CatalogStats = lazy(
  () => import('./components/CatalogStats/CatalogStats'),
)
const ItemsProduction = lazy(
  () =>
    import('./components/ItemsOperecion/ItemsProduction'),
)
const NoAccess = lazy(
  () => import('./components/NoAccess/NoAccess'),
)
const TestFunc = lazy(
  () => import('./components/TESTFUNC/TestFunc'),
)
const SpoManager = lazy(
  () => import('./components/SPOManager/SpoManager'),
)
const BuyerProduction = lazy(
  () =>
    import('./components/BuyerOperecion/BuyerProduction'),
)
const LowProfit = lazy(
  () => import('./components/LowProfit/LowProfit'),
)
const MBAppPage = lazy(
  () => import('./components/MBAppPage/MBAppPage'),
)
const ProductsManager = lazy(
  () =>
    import('./components/ProductsManager/ProductsManager'),
)
const ProductsManagerHistory = lazy(
    () =>
        import('./components/ProductsManager/ProductsManagerHistory/ProductsManagerHistory'),
)
const StockProduction = lazy(
  () =>
    import('./components/StockOperacion/StockProduction'),
)
const Logistic = lazy(() =>
  import('./components/Logistic/Logistic').then(
    (module) => ({
      default: module.Logistic,
    }),
  ),
)
const SuppliersProduction = lazy(
  () =>
    import(
      './components/SuppliersProduction/SuppliersProduction'
    ),
)
const SalesForCom = lazy(
  () => import('./components/SalesForCom/SalesForCom'),
)
const MessagesPage = lazy(
  () => import('./components/Messages/MessagesPage'),
)
const BuyerListProduction = lazy(
  () =>
    import(
      './components/BuyerListProduction/BuyerListProduction'
    ),
)
const PickingPage = lazy(
  () => import('./components/PickingPage/PickingPage.jsx'),
)
const DebtorsPage = lazy(
  () => import('./components/DebtorsPage/DebtorsPage'),
)
const SuppliersDebtorsPage = lazy(
  () =>
    import(
      './components/SuppliersDebtorsPage/SuppliersDebtorsPage'
    ),
)
const LogisticHistory = lazy(
  () =>
    import(
      './components/LogisticHistory/LogisticHistory.jsx'
    ),
)
const ResultsPage = lazy(
  () => import('./components/ResultsPage/ResultsPage.jsx'),
)
const BotTimer = lazy(
  () => import('./components/BotTimer/BotTimer'),
)
const MeetingPage = lazy(
  () => import('./components/MeetingPage/MeetingPage.jsx'),
)
const Vacation = lazy(
  () => import('./components/Vacation/Vacation.jsx'),
)

function App() {

  const { SUPPLIERS_LIST, isLoading } = useSuppliersList()

  const loginObj = {
    VPF: 'aHreSEqUAgRa',
    TPO: 'URoSIBInGLIs',
  }
  const location = useLocation()
  const [name, setName] = useState(
    localStorage.getItem('name') || '',
  )
  const [password, setPassword] = useState(
    localStorage.getItem('password') || '',
  )
  const [isAutorization, setIsAutorization] = useState(
    localStorage.getItem('password') ===
      loginObj[localStorage.getItem('name')] || false,
  )

  const usr = JSON.parse(localStorage.getItem('acc'))

  const { data: siteParams, isSuccess } =
    mainApi.useGetSiteParamsByIdQuery(
      { _id: usr?.site ? usr?.site : '' },
      { skip: !usr?.site },
    )

  useEffect(() => {
    // Функция для обновления siteParams в localStorage
    const updateSiteParams = () => {
      if (isSuccess && siteParams) {
        // console.log('Updating siteParams:', siteParams)
        localStorage.setItem(
          'site',
          JSON.stringify(siteParams),
        )
      }
    }

    // Вызываем обновление каждые 30 минут (30 * 60 * 1000 миллисекунд)
    const interval = setInterval(
      () => {
        updateSiteParams()
      },
      30 * 60 * 1000,
    )

    // Запускаем обновление сразу при первом рендере
    updateSiteParams()

    // Очищаем интервал при размонтировании компонента
    return () => clearInterval(interval)
  }, [isSuccess, siteParams])

  //settings exp
  // const settings = useSelector((state) => state.userSettings.settings)

  // const [headerImage, setHeaderImage] = useState(settings.headerImage)
  // const [adminName, setAdminName] = useState(settings.adminName)

  // useEffect(() => {
  //   setHeaderImage(settings.headerImage)
  //   setAdminName(settings.adminName)
  // }, [settings])

  //WX+ZXyLEa5!3kBJf
  return (
    <ThemeProvider theme={theme}>
      <div className='App'>
        {location.pathname.split('/')[2] !== 'static' &&
          location.pathname.split('/')[1] !== 'buyerList' &&
          SUPPLIERS_LIST.some(
            (item) =>
              item.link !== location.pathname.split('/')[1],
          ) && <Header />}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ErrorBoundary>
            <PermissionsProvider>
              {/*<DebugPermissions />*/}
              {/*<PermissionsTest />*/}
              {/* {isAutorization && localStorage.getItem('password') === loginObj[localStorage.getItem('name')] ? ( */}
              {localStorage.getItem('acc') ? (
                <Suspense fallback={<LoadingFallback />}>
                  <Routes>
                    <Route
                      path='/'
                      element={
                        <Navigate
                          replace
                          to='/admin/orders'
                        />
                      }
                      action={
                        isAutorization &&
                        password === 'WX+ZXyLEa5!3kBJf'
                          ? {}
                          : { replace: true, to: '/auth' }
                      }
                    />
                    <Route
                      path='/admin/orders'
                      element={
                        <ProtectedRoute requiredPermission='orders.canView'>
                          <Orders />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/welcome'
                      element={<WelcomePage />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/contacts'
                      element={
                        <ProtectedRoute requiredPermission='contacts.canView'>
                          <Contacts />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/contactsStats'
                      element={<ContactStats />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/orders/:id'
                      element={
                        <ProtectedRoute requiredPermission='orders.canView'>
                          <OrdersChange />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/contacts/:id'
                      element={
                        <ProtectedRoute requiredPermission='contacts.canView'>
                          <ContactChange />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/catalog'
                      element={
                        <ProtectedRoute requiredPermission='catalog.canView'>
                          <Catalog />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/catalog/:id'
                      element={
                        <ProtectedRoute requiredPermission='catalog.canView'>
                          <CatalogChange />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/history'
                      element={<History />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/history/:search'
                      element={<History />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/shipment'
                      element={
                        <ProtectedRoute requiredPermission='operations.shipment.canView'>
                          <ShipmentOrders />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/shopping'
                      element={<ItemsProduction />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/buyer'
                      element={<BuyerProduction />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/logistic'
                      element={
                        <ProtectedRoute requiredPermission='logistic.canView'>
                          <Logistic />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/logistic/history'
                      element={
                        <ProtectedRoute requiredPermission='logistic.canView'>
                          <LogisticHistory />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/MBApp'
                      element={<MBAppPage />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/client/static/:id'
                      element={<StaticPage />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/botTimer'
                      element={<BotTimer />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/ordersHistory'
                      element={<OrdersHistory />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/ordersHistory/:id'
                      element={<OrdersChange />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/profile'
                      element={<Profile />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/client/static/order/:id'
                      element={<StaticOrderFP />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/logs'
                      element={<LogsPage />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/catalogStats'
                      element={<CatalogStats />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/noAccess'
                      element={<NoAccess />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/picking'
                      element={
                        <ProtectedRoute requiredPermission='operations.shipment.canView'>
                          <PickingPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/addSite'
                      element={<TestFunc />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/lowAnalyzer'
                      element={<LowProfit />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/productsManager'
                      element={<ProductsManager />}
                    />
                    <Route
                        errorElement={<ErrorBoundary />}
                        path='/admin/productsManager/history'
                        element={<ProductsManagerHistory />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/stock'
                      element={<StockProduction />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/salesforCom'
                      element={<SalesForCom />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/debtors'
                      element={<DebtorsPage />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/year'
                      element={<ResultsPage />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/spoManagement'
                      element={<SpoManager />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/messages'
                      element={
                        <ProtectedRoute requiredPermission='messages.canView'>
                          <MessagesPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='*'
                      element={<SpoManager />}
                    />

                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/juice'
                      element={<JuiceProduction />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/supDebt'
                      element={<SuppliersDebtorsPage />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/meetings'
                      element={<MeetingPage />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/vacations'
                      element={<Vacation />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/juice'
                      element={<JuiceProduction />}
                    />
                    {SUPPLIERS_LIST.map((el) => (
                      <React.Fragment key={el.link}>
                        <Route
                          errorElement={<ErrorBoundary />}
                          path={'/' + el.link}
                          element={
                            <SuppliersProduction
                              item={el}
                            />
                          }
                        />
                        <Route
                          errorElement={<ErrorBoundary />}
                          path={'/admin/' + el.link}
                          element={
                            <SuppliersProduction
                              item={el}
                            />
                          }
                        />
                      </React.Fragment>
                    ))}
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/buyerList'
                      element={<BuyerListProduction />}
                    />
                  </Routes>
                </Suspense>
              ) : (
                <Suspense fallback={<LoadingFallback />}>
                  <Routes>
                    <Route
                      path='/'
                      element={
                        <Navigate replace to='/auth' />
                      }
                    />
                    <Route
                      path='/auth'
                      element={
                        // <OldAutorization
                        //   loginObj={loginObj}
                        //   name={name}
                        //   setName={setName}
                        //   password={password}
                        //   setPassword={setPassword}
                        //   setIsAutorization={setIsAutorization}
                        // />
                        <Autorization />
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/admin/botTimer'
                      element={<BotTimer />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/juice'
                      element={<JuiceProduction />}
                    />
                    {SUPPLIERS_LIST.map((el) => (
                      <Route
                        key={el.link}
                        errorElement={<ErrorBoundary />}
                        path={'/' + el.link}
                        element={
                          <SuppliersProduction item={el} />
                        }
                      />
                    ))}
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/buyerList'
                      element={<BuyerListProduction />}
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/client/static/*'
                      element={<StaticPage />}
                    />
                    <Route
                      path='*'
                      element={
                        <Navigate replace to='/auth' />
                      }
                    />
                    <Route
                      errorElement={<ErrorBoundary />}
                      path='/client/static/order/:id'
                      element={<StaticOrderFP />}
                    />
                  </Routes>
                </Suspense>
              )}
            </PermissionsProvider>
          </ErrorBoundary>
        </LocalizationProvider>
      </div>
    </ThemeProvider>
  )
}

export default App
